import Link from "next/link";
import { useShowRowContext } from "@/components/shows";

export function ShowRowLocation() {
  const { shows } = useShowRowContext();
  const uniqueLocations = [...new Set(shows.map((s) => s.location))];

  const className = "text-base text-primary-blue font-medium line-clamp-1";

  if (shows.length > 1 && uniqueLocations.length > 1) {
    // note: no Link for multiple locations yet, we don't have show/event pages for multiple events yet.
    return <p className={className}>Multiple locations</p>;
  }

  const show = shows[0];
  return (
    <Link href={`/e/${show.id}`}>
      <p className={className}>{show.location}</p>
    </Link>
  );
}
